/**
 * User: hella
 * Date: 6/22/14
 * Time: 3:07 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';

var _ = require('underscore');
var $ = require('dibs-jquery-shim');
var SV = require('server-vars');
var strings = require('dibs-strings-helper');
var purchaseTracking = require('../../mixins/purchaseTracking.es');
var tracking = require('dibs-tracking');
var pdpTracking = require('../../../newPdp/helpers/pdpTracking');
var copyText = require('bunsen/helpers/copyText')();
var undefined = void (0);

/**
 * initialize ga
 * @param dom {Object} object containing form dom elements
 * @param options.type {string} friend or dealer
 */
var ModalEmailTracking = module.exports = function () {
    var customVars = SV.get('tracking.customVars');

    if (customVars && customVars.length) {
        this._customVar4 = customVars[0].value;
    }
};
_.extend(ModalEmailTracking.prototype, {
    _subType: 'Email Friend Modal',
    /**
     * virtual page view
     * @param virtualUrl {string} vpv string
     */
    firePageViewGAEvent: function (virtualUrl) {
        // this prevents re-firing of any ecommerce events that already happened
        tracking.addGTMMessage({ecommerce: undefined});
        return tracking.trackPageview({
            url: pdpTracking.amendCustomVar(virtualUrl, 'ret', this._getValueFromCustomVarString('ret') === 'y'),
            additional: {
                pageType: 'Other',
                pageSubType: this._subType
            }
        });
    },

    resetPageViewVars: function () {
        return tracking.addGTMMessage({
            pageType: SV.get('tracking.initialDataLayerInfo.pageType'),
            pageSubType: SV.get('tracking.initialDataLayerInfo.pageSubType')
        });
    },

    /**
     * @param options.linkLocation where was link/button located that launched the modal
     * @param options.fromForm form submitted or contact dealer or email friend clicked
     * @param options.emailShared
     */
    fireCommunicationGAEvent: function (options) {
        var details = this._details(options);
        return tracking.trackEvent(_.extend(details, {
            value: options.emailShared,
            category: details.event
        }));
    },
    /**
     *
     * @param options.fromForm flag that determines if form was submitted or contact dealer or email friend was clicked
     * @param options.itemPk string that contains the emailed item's PK, in case you're on a page with more than one item (eg favorites)
     * @returns details about friend needed for fireContactGAEvent
     */
    _details: function (options) {
        var details = {};

        details.event = 'email a friend';
        details.label = options.itemPk || this._getValueFromCustomVarString('id');

        if ('' + details.label) {
            details.label = 'item|' + details.label;
            details.shareType = 'item';
        } else {
            details.label = 'folder';
            details.shareType = 'folder';
        }

        if (options.fromForm) {
            details.action = 'email a friend sent';
        } else {
            details.action = 'email a friend initiated';
            delete details.shareType;
        }

        return details;
    },
    _getActionBase: function () {
        return 'email a friend';
    },
    /**
     * validation error fields
     * @param options.errors {Array} fire one event for each error
     * @param [options.isOffer] {boolean} error relates to offer
     */

    fireValidationGAEvent: function (options) {
        options = _.extend({
            errors: []
        }, options);
        return options.errors.map(function (error) {
            return tracking.trackFormError({
                action: this._getActionBase(_.pick(options, 'isOffer')) + '|modal email form|' + error.name,
                label: error.message.toLowerCase()
            });
        }.bind(this));
    },

    fireDealerSendGAEvent: function (linkLocation) {
        return tracking.trackEvent({
            category: 'contact dealer',
            action: 'contact dealer send clicked',
            label: linkLocation
        });
    },

    fireAddToCartGAEvent: function () {
        return purchaseTracking.ecommerceAddToCartTracking({
            id: SV.get('data.pk'),
            name: SV.get('data.titleCondensed'),
            brand: SV.get('tracking.initialDataLayerInfo.dealerID'),
            price: SV.get('tracking.initialDataLayerInfo.askingPrice'),
            category: SV.get('tracking.initialDataLayerInfo.pageSection').replace(' ', '-').toLowerCase()
        });
    },

    /**
     * fire offer related event
     * @param {string} options.action ga action
     * @param {boolean} [options.prependOfferLowMsg] prepend lowball offer error copy to action
     * @param {boolean} [options.isError]
     */
    fireOfferGAEvent: function (options) {
        var actionVal = [];
        var event;
        var label;
        options = _.extend({
            action: undefined,
            prependOfferLowMsg: undefined,
            isError: undefined
        }, options);
        event = options.isError ? 'Offer Errors' : 'Offer Actions';
        label = [
            'neg=' + this._getValueFromCustomVarString('neg'),
            //MONEY-14 need to get fresh shipping and return info from custom var since PDPs cached
            'ship=' + this._getValueFromCustomVarString('ship'),
            'ret=' + this._getValueFromCustomVarString('ret')
        ].join('|');

        if (options.prependOfferLowMsg) {
            actionVal.push(copyText.get('contactDealer.lowballTitle'));
            if (options.action) {
                // if there's a header and an action value, make sure to add a separator
                actionVal.push(' - ');
            }
        }
        // if there is no `action` variable, the action will become an empty string
        actionVal.push(options.action || '');
        return tracking.trackEvent({
            category: event,
            action: actionVal.join(''),
            label: label
        });
    },

    /**
     * pull values from custom var.
     * If key=A, customVar4='A=x|B=y|C=z', it will return x
     * @param key {string} search key
     * @returns {String|Boolean}
     */
    _getValueFromCustomVarString: function (key) {
        return strings.getFromDelimitedString(this._customVar4, key, '\\|');
    }
});
module.exports.Dealer = function () {
    return ModalEmailTracking.apply(this, arguments);
};
module.exports.Dealer.prototype = _.extend({}, ModalEmailTracking.prototype, {
    _getActionBase: function (options) {
        options = _.extend({
            isOffer: undefined
        }, options);
        return options.isOffer ? 'offer' : 'contact dealer';
    },
    _subType: 'Contact Dealer Modal',
    /**
     * @param linkLocation where was link/button located that launched the modal
     * @param form flag that determines if form was submitted or contact dealer or email friend was clicked
     * @value if true indicates that user has shared email with the dealer
     * @returns details about dealer needed for fireContactGAEvent
     */
    _details: function (options) {
        var details = {
            event: 'contact dealer',
            label: options.linkLocation,
            action: 'contact dealer clicked'
        };
        if (!options.fromForm) {
            return details;
        }
        $.publish('ga:visitor:contactDealer'); // TODO: remove this line if it is in any way related to tracking
        return _.extend(details, {
            action: 'contact dealer submitted',
            additional: {
                contactDealerStatus: 'dealer contacted'
            }
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/modalEmail/tracking.js
// module id = 943
// module chunks = 4 7 12